/* eslint-disable import/no-extraneous-dependencies, import/no-unresolved, import/extensions */
import { createPerimeter } from 'vue-kindergarten';
/* eslint-enable */

export default createPerimeter({
  purpose: 'oci',

  can: {
    // page access guarded by auth-routes.  these rules set up the perimeter for page level access rights

    view() {
      return true;
    },


    sendMarketingCampaign() {
      return this.isSuper();
    },
    viewBrokerChat() {
      return this.isSuper() // || this.isOciBroker(); for now disabled to broker use
    },
    useBrokerChat() {
      return this.isOciBroker()
    },
    viewMortgageApp() {
      return this.isSuper() || this.isOciBroker();
    },
    useMortgageApp() {
      return this.isSuper() || this.isOciBroker()
    },
    sendCreditRequestPROD() {
      return this.isOciCreditRequester() || this.isOciBrokerManager()
    },
    sendCreditRequestUAT() {
      return this.isSuper()
    },
    requestCreditBureau() {
      return this.isSuper() || this.isOciCreditRequester() || this.isOciBrokerManager()
    },

    submitToLender() {
      return   this.isOciBrokerManager() || this.isOciLenderTransmitter()
    },
// Dashboard Menu Items
    viewAdminDashboard(){
      return this.isSuper()
    },

    // Dashboard Menu Items
    viewOciDashboard(){
      return this.isSuper() || this.isOciBroker()
    },
    viewOciOperationsDashboard(){
      return this.isSuper() || this.isOciFinanceDirector()
    },
    viewPartnerDashboard(){
      return this.isSuper() || this.isPartner() ||  this.isOciBrokerManager()
    },
  },

  isSuper() {
    return this.child.isSuper;
  },
  isOci() {
    return this.child.isOci;
  },

  isPartner() {
    return this.child.isPartner;
  },
  isPartnerFounder() {
    return this.child.isPartnerFounder;
  },
  isPartnerInvestor() {
    return this.child.isPartnerInvestor;
  },
  isOciBroker() {
    return this.child.isOciBroker;
  },
  isOciBrokerManager() {
    return this.child.isOciBrokerManager;
  },
  isOciManager() {
    return this.child.isOciManager;
  },
  isOciDeveloper() {
    return this.child.isOciDeveloper;
  },
  isOciLenderTransmitter() {
    return this.child.isOciLenderTransmitter;
  },
  isOciCreditRequester() {
    return this.child.isOciCreditRequester;
  },
  isOciGroup() {
    return this.child.isOciGroup;
  },
  isLenderGroup() {
    return this.child.isLenderGroup;
  },
  isSuperGroup() {
    return this.child.isSuperGroup;
  },
  isDeveloperGroup() {
    return this.child.isDeveloperGroup;
  },
  isPartnerGroup() {
    return this.child.isPartnerGroup;
  },
  isOciFinanceDirector() {
    return this.child.isOciFinanceDirector;
  },





});
